import {CommonModule} from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output, TemplateRef,
} from '@angular/core';
import {NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'atl-button-loader',
  templateUrl: './button-loader.component.html',
  styleUrls: ['./button-loader.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, NgbTooltipModule]
})
export class ButtonLoaderComponent {
  @Input() loading = false;
  @Input() disabled = false;
  @Input() label = '';
  @Input() addClass = {};
  @Input() newest = true;
  @Input() tooltip: string | TemplateRef<any> = ''
  @Input() tooltipDelay = 0;
  @Input() showTooltip = false;
  @Input() outline = false;
  @Input() red = false;

  @Output() clickButton: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  onClickButton(event: MouseEvent): void {
    if (!this.loading) {
      this.clickButton.emit(event);
    }
  }

  get customClass(): any {
    return {
      ...this.addClass,
      ['loading']: this.loading,
      ['newest-button--outline']: this.outline,
      ['button-red']: this.red
    }
  }
}
